import {DialogTypes} from 'common/names';
import {layoutActions} from 'features/layout/redux';
import i18n from 'i18n';
import {call, put, race} from 'redux-saga/effects';
import {takeDialogResult} from 'redux/common/saga/takeDialogResult';
import {initRestoreDialogProcess} from './initRestoreDialogProcess';

export function* openRestoreDialog(dbFilePath: string, config: boolean, password: string) {
   yield put(
      layoutActions.openSubDialog({
         id: DialogTypes.StatusDialog.id,
         data: {
            title: i18n.t('Transaction Datastore Restore'),
         },
      })
   );

   yield race([
      call(takeDialogResult, DialogTypes.StatusDialog.id),
      call(initRestoreDialogProcess, dbFilePath, config, password),
   ]);
}
